document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".image-column-slider").forEach((slideContainer) => {
      var nextBtn = slideContainer.querySelector(".next-ar");
      var prevBtn = slideContainer.querySelector(".prev-ar");

      if (nextBtn && prevBtn) {
        var slidesWidth = slideContainer.querySelector(".column-slide").offsetWidth;
        var scrollsAmount = slidesWidth + 10;

        nextBtn.addEventListener("click", () => {
          slideContainer.scrollBy({
            left: scrollsAmount,
            behavior: "smooth",
          });
        });

        prevBtn.addEventListener("click", () => {
          slideContainer.scrollBy({
            left: -scrollsAmount,
            behavior: "smooth",
          });
        });
      } else {
        console.error("Next or Previous button not found in this slider:", slideContainer);
      }
    });
});
